import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  Pagination,
  Stack,
  Typography,
} from '@mui/material';
import dayjs from 'dayjs';
import {
  useGetFeedbacksQuery,
} from 'api/services/dataEndpoints';
import type { FeedbackType } from 'types/apiTypes/feedbackTypes';

const PAGE_SIZE = 20;

const FeedbackList: React.FC = () => {
  const [page, setPage] = React.useState(1);
  const { data: response, isLoading, isError, refetch } = useGetFeedbacksQuery({
    page,
    page_size: PAGE_SIZE,
  });
  console.log('response', response);
  const { data: list, pagination } = response || {};

  const totalPages = pagination?.total_pages || 1;

  const renderContent = () => {
    if (isLoading) {
      return (
      <Stack alignItems="center" justifyContent="center" sx={{ height: 180 }}>
        <CircularProgress />
      </Stack>
      );
    }

    if (isError) {
      return <Typography color="error">Failed to load feedbacks</Typography>;
    }

    console.log('list', list);

    return (
      <Box>
        {list?.map((f: FeedbackType) => (
        <Card key={f.id} sx={{ mb: 2 }}>
          <CardContent>
            <Typography variant="h6" sx={{ mb: 1 }}>{f.user.email}</Typography>
            <Typography>{f.text}</Typography>
            <Typography variant="caption" color="#333">{dayjs(f.created_at).format('MM-DD-YYYY HH:mm')} </Typography>
          </CardContent>
        </Card>
        ))}
        {list?.length === 0 && (
          <Card>
            <CardContent>
              <Typography>No feedbacks yet</Typography>
            </CardContent>
          </Card>
        )}

        <Stack alignItems="center" sx={{ mt: 1 }}>
          <Pagination
            size="small"
            page={page}
            count={totalPages}
            onChange={(_, p) => setPage(p)}
            />
        </Stack>
      </Box>
    );
  };

  return renderContent();
};

export default FeedbackList;
